// 知识库
const knowledge = [
  {
    path: '/notice',
    name: 'noticePage',
    meta: { tag: '公告' },
    component: () => import('@/pages/NoticePage')
  },
  {
    path: '/faq',
    name: 'faqPage',
    meta: { tag: '知识库' },
    component: () => import('@/pages/FaqPage')
  }
]

export default knowledge
